import React from 'react';
import { Users, TrendingUp, Award, Zap, Target, Heart } from 'lucide-react';

const Features = () => {
  const features = [
    {
      icon: Users,
      title: 'Community First',
      description: 'Join a supportive community where everyone lifts each other up. Real connections, real support.',
      gradient: 'from-cyan-400 to-blue-500',
      bgColor: 'bg-blue-50',
      image: 'https://images.unsplash.com/photo-1540058404349-2e5fabf32d75?w=400&q=80'
    },
    {
      icon: TrendingUp,
      title: 'Learn & Earn',
      description: 'Start making money from day one. No debt, no waiting—just learning and earning together.',
      gradient: 'from-pink-400 to-purple-500',
      bgColor: 'bg-purple-50',
      image: 'https://images.unsplash.com/photo-1695066964145-245927509533?w=400&q=80'
    },
    {
      icon: Award,
      title: 'Real-World Skills',
      description: 'Learn what employers actually want. No fluff, just practical skills that land you jobs.',
      gradient: 'from-teal-400 to-green-500',
      bgColor: 'bg-teal-50',
      image: 'https://images.unsplash.com/photo-1675664535114-99fcb3c80c82?w=400&q=80'
    }
  ];

  const benefits = [
    { icon: Zap, text: 'Fast-track to tech careers', color: 'text-yellow-500' },
    { icon: Target, text: 'Industry-focused curriculum', color: 'text-blue-500' },
    { icon: Heart, text: 'Supportive mentorship', color: 'text-pink-500' }
  ];

  return (
    <section id="features" className="py-20 px-6 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose 317?
          </h2>
          <div className="section-underline"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We're not just another coding bootcamp. We're a movement to democratize tech education.
          </p>
        </div>

        {/* Feature Cards with Images */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div key={index} className="feature-card group">
                {/* Image with Overlay */}
                <div className="relative h-48 rounded-xl overflow-hidden mb-6">
                  <img 
                    src={feature.image} 
                    alt={feature.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className={`absolute inset-0 bg-gradient-to-br ${feature.gradient} opacity-20 group-hover:opacity-30 transition-opacity`}></div>
                </div>
                
                {/* Icon */}
                <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${feature.gradient} flex items-center justify-center mb-4 shadow-lg transform group-hover:scale-110 transition-transform`}>
                  <Icon className="text-white" size={32} />
                </div>
                
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Additional Benefits Bar */}
        <div className="bg-gradient-to-r from-cyan-50 to-blue-50 rounded-2xl p-8">
          <div className="grid md:grid-cols-3 gap-6">
            {benefits.map((benefit, index) => {
              const Icon = benefit.icon;
              return (
                <div key={index} className="flex items-center gap-4">
                  <div className={`${benefit.color}`}>
                    <Icon size={28} strokeWidth={2.5} />
                  </div>
                  <span className="text-gray-700 font-medium">{benefit.text}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;